module.exports = __webpack_public_path__ + "static/img/md-wdj.8b7a557b.png";